(function () {
  'use strict';

  if (window.__stylikaMetafieldNavigationLoadedV10) return;
  window.__stylikaMetafieldNavigationLoadedV10 = true;

  function loadDeferredImages(scope) {
    if (!scope) return;

    scope.querySelectorAll('img[data-snv-src]').forEach(function (image) {
      if (image.dataset.snvSrcset) {
        image.srcset = image.dataset.snvSrcset;
        image.removeAttribute('data-snv-srcset');
      }

      image.src = image.dataset.snvSrc;
      image.removeAttribute('data-snv-src');
    });
  }

  function activateMobileTab(button) {
    var root = button.closest('[data-snv-mobile]');
    if (!root) return;

    var name = button.getAttribute('data-snv-mobile-tab');
    if (!name) return;

    root.querySelectorAll('[data-snv-mobile-tab]').forEach(function (tab) {
      var active = tab === button;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-snv-mobile-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-snv-mobile-panel') === name;
      panel.hidden = !active;

      if (active) {
        var openSection = panel.querySelector('details[open]');
        var featuredSection = panel.querySelector('.snv-mobile-featured');

        if (openSection) loadDeferredImages(openSection);
        if (featuredSection) loadDeferredImages(featuredSection);

        if (!openSection && !featuredSection) {
          loadDeferredImages(panel);
        }
      }
    });
  }

  function cancelPanelAnimations(panel) {
    if (!panel) return;

    if (typeof panel.getAnimations === 'function') {
      panel.getAnimations({ subtree: true }).forEach(function (animation) {
        animation.cancel();
      });
    }

    [panel, panel.firstElementChild, panel.lastElementChild].forEach(function (element) {
      if (!element || !element.style) return;
      element.style.removeProperty('transform');
      element.style.removeProperty('translate');
      element.style.removeProperty('opacity');
      element.style.removeProperty('visibility');
    });
  }

  function activateDesktopTab(button) {
    var navigation = button.closest('[data-snv-desktop]');
    if (!navigation) return;

    var targetId = button.getAttribute('aria-controls');
    var targetPanel = targetId ? document.getElementById(targetId) : null;
    if (!targetPanel) return;

    var currentPanel = navigation.querySelector('[data-snv-panel]:not([hidden])');
    if (currentPanel === targetPanel && button.disabled) {
      loadDeferredImages(targetPanel);
      initCarousels(targetPanel);
      return;
    }

    var pageX = window.scrollX;
    var pageY = window.scrollY;
    var megaMenu = navigation.closest('.mega-menu');
    var megaContainer = navigation.closest('.mega-menu__container');
    var megaMenuScrollTop = megaMenu ? megaMenu.scrollTop : 0;
    var containerScrollTop = megaContainer ? megaContainer.scrollTop : 0;

    navigation.querySelectorAll('[role="tab"][aria-controls]').forEach(function (tab) {
      var active = tab === button;
      tab.disabled = active;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    navigation.querySelectorAll('[data-snv-panel]').forEach(function (panel) {
      cancelPanelAnimations(panel);
      panel.hidden = panel !== targetPanel;
    });

    cancelPanelAnimations(targetPanel);
    loadDeferredImages(targetPanel);
    initCarousels(targetPanel);

    window.requestAnimationFrame(function () {
      cancelPanelAnimations(targetPanel);

      if (megaMenu) megaMenu.scrollTop = megaMenuScrollTop;
      if (megaContainer) megaContainer.scrollTop = containerScrollTop;

      if (window.scrollX !== pageX || window.scrollY !== pageY) {
        window.scrollTo(pageX, pageY);
      }
    });
  }

  function resetDesktopNavigation(navigation) {
    if (!navigation) return;

    var firstTab = navigation.querySelector('[role="tab"][aria-controls]');
    if (!firstTab) return;

    activateDesktopTab(firstTab);

    var firstPanelId = firstTab.getAttribute('aria-controls');
    var firstPanel = firstPanelId ? document.getElementById(firstPanelId) : null;
    if (!firstPanel) return;

    firstPanel.querySelectorAll('[data-snv-carousel-viewport]').forEach(function (viewport) {
      viewport.scrollLeft = 0;
      updateCarouselState(viewport);
    });
  }

  function getCarouselViewportFromButton(button) {
    var id = button.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function getCarouselStep(viewport) {
    if (!viewport) return 0;

    var card = viewport.querySelector('[data-snv-carousel-track] > *');
    if (!card) return Math.max(240, viewport.clientWidth * 0.75);

    var track = viewport.querySelector('[data-snv-carousel-track]');
    var styles = track ? window.getComputedStyle(track) : null;
    var gap = styles ? parseFloat(styles.columnGap || styles.gap || 0) : 0;

    return card.getBoundingClientRect().width + gap;
  }

  function updateCarouselState(viewport) {
    if (!viewport) return;

    var carousel = viewport.closest('[data-snv-carousel]');
    var panel = viewport.closest('[data-snv-panel], .snv-flat-panel, .mega-menu__item');
    var controls = panel ? panel.querySelector('[data-snv-carousel-controls]') : null;
    var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    var overflow = maxScroll > 2;
    var atStart = viewport.scrollLeft <= 2;
    var atEnd = viewport.scrollLeft >= maxScroll - 2;

    if (carousel) carousel.classList.toggle('is-overflowing', overflow);
    if (controls) {
      controls.classList.toggle('is-visible', overflow);
      var previous = controls.querySelector('[data-snv-carousel-prev]');
      var next = controls.querySelector('[data-snv-carousel-next]');
      if (previous) previous.disabled = !overflow || atStart;
      if (next) next.disabled = !overflow || atEnd;
    }
  }


  function maybeAutoPeekCarousel(viewport) {
    if (!viewport) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (viewport.dataset.snvPeeked === 'true') return;
    if (viewport.hidden || viewport.offsetParent === null || viewport.clientWidth < 40) return;

    var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    if (maxScroll < 48 || viewport.scrollLeft > 2) return;

    viewport.dataset.snvPeeked = 'true';

    window.setTimeout(function () {
      if (viewport.dataset.snvUserInteracted === 'true') return;
      if (viewport.offsetParent === null) return;

      var currentMax = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (currentMax < 48 || viewport.scrollLeft > 2) return;

      var peekDistance = Math.min(88, Math.max(56, currentMax * 0.18));
      viewport.scrollTo({ left: peekDistance, behavior: 'smooth' });

      window.setTimeout(function () {
        if (viewport.dataset.snvUserInteracted === 'true') return;
        if (viewport.offsetParent === null) return;
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
      }, 620);
    }, 320);
  }

  function setupCarousel(carousel) {
    if (!carousel || carousel.dataset.snvCarouselReady === 'true') return;

    var viewport = carousel.querySelector('[data-snv-carousel-viewport]');
    if (!viewport) return;

    carousel.dataset.snvCarouselReady = 'true';

    viewport.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        updateCarouselState(viewport);
      });
    }, { passive: true });

    ['pointerdown', 'touchstart'].forEach(function (eventName) {
      viewport.addEventListener(eventName, function () {
        viewport.dataset.snvUserInteracted = 'true';
      }, { passive: true, once: true });
    });

    viewport.addEventListener('wheel', function (event) {
      viewport.dataset.snvUserInteracted = 'true';
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (viewport.scrollWidth <= viewport.clientWidth + 2) return;

      var horizontalIntent = Math.abs(event.deltaX) > Math.abs(event.deltaY);
      var delta = horizontalIntent ? event.deltaX : event.deltaY;
      if (!delta) return;

      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var atStart = viewport.scrollLeft <= 2;
      var atEnd = viewport.scrollLeft >= maxScroll - 2;

      if ((delta < 0 && atStart) || (delta > 0 && atEnd)) {
        return;
      }

      event.preventDefault();
      viewport.scrollBy({ left: delta, behavior: 'auto' });
    }, { passive: false });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        updateCarouselState(viewport);
      });
      observer.observe(viewport);
      var track = viewport.querySelector('[data-snv-carousel-track]');
      if (track) observer.observe(track);
    }

    window.requestAnimationFrame(function () {
      updateCarouselState(viewport);
      maybeAutoPeekCarousel(viewport);
    });
  }

  function initCarousels(root) {
    if (!root) return;

    if (root.matches && root.matches('[data-snv-carousel]')) {
      setupCarousel(root);
    }

    root.querySelectorAll('[data-snv-carousel]').forEach(setupCarousel);
    root.querySelectorAll('[data-snv-carousel-viewport]').forEach(function (viewport) {
      updateCarouselState(viewport);
      maybeAutoPeekCarousel(viewport);
    });
  }

  document.addEventListener('click', function (event) {
    var mobileTab = event.target.closest('[data-snv-mobile-tab]');
    if (mobileTab) {
      event.preventDefault();
      activateMobileTab(mobileTab);
      return;
    }

    var carouselButton = event.target.closest('[data-snv-carousel-prev], [data-snv-carousel-next]');
    if (carouselButton) {
      event.preventDefault();
      var viewport = getCarouselViewportFromButton(carouselButton);
      if (!viewport) return;

      var direction = carouselButton.hasAttribute('data-snv-carousel-prev') ? -1 : 1;
      viewport.scrollBy({
        left: getCarouselStep(viewport) * direction,
        behavior: 'smooth'
      });
      return;
    }

    var desktopTab = event.target.closest('[data-snv-desktop] [role="tab"][aria-controls]');
    if (desktopTab) {
      event.preventDefault();
      event.stopImmediatePropagation();
      activateDesktopTab(desktopTab);
    }
  }, true);

  document.addEventListener('pointerover', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var megaDetails = event.target.closest('details[is="details-mega"]');
    if (megaDetails) {
      var desktopNavigation = megaDetails.querySelector('[data-snv-desktop]');
      if (desktopNavigation) {
        var visiblePanel = desktopNavigation.querySelector('[data-snv-panel]:not([hidden])') || desktopNavigation;
        loadDeferredImages(visiblePanel);
        initCarousels(visiblePanel);
      }
    }

    var desktopTab = event.target.closest('[data-snv-desktop] [role="tab"][aria-controls]');
    if (!desktopTab) return;
    if (event.relatedTarget && desktopTab.contains(event.relatedTarget)) return;

    var target = document.getElementById(desktopTab.getAttribute('aria-controls'));
    loadDeferredImages(target);

    window.clearTimeout(desktopTab._snvHoverTimer);
    desktopTab._snvHoverTimer = window.setTimeout(function () {
      if (desktopTab.matches(':hover')) {
        activateDesktopTab(desktopTab);
      }
    }, 120);
  });

  document.addEventListener('pointerout', function (event) {
    var desktopTab = event.target.closest('[data-snv-desktop] [role="tab"][aria-controls]');
    if (!desktopTab) return;
    if (event.relatedTarget && desktopTab.contains(event.relatedTarget)) return;

    window.clearTimeout(desktopTab._snvHoverTimer);
  });

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;

    /* Mobile accordion: keep only one category open inside the active tab. */
    if (details.matches('details.snv-mobile-section')) {
      var mobilePanel = details.closest('[data-snv-mobile-panel]');

      if (mobilePanel) {
        mobilePanel.querySelectorAll('details.snv-mobile-section[open]').forEach(function (otherSection) {
          if (otherSection !== details) otherSection.open = false;
        });
      }

      loadDeferredImages(details);
      return;
    }

    var desktop = details.querySelector('[data-snv-desktop]');
    if (desktop) {
      resetDesktopNavigation(desktop);
      var activeDesktopPanel = desktop.querySelector('[data-snv-panel]:not([hidden])');
      var desktopScope = activeDesktopPanel || desktop;
      cancelPanelAnimations(activeDesktopPanel);
      loadDeferredImages(desktopScope);
      initCarousels(desktopScope);
      return;
    }

    var mobile = details.querySelector('[data-snv-mobile]');
    if (mobile) {
      var activeMobilePanel = mobile.querySelector('[data-snv-mobile-panel]:not([hidden])');
      var openMobileSection = activeMobilePanel && activeMobilePanel.querySelector('details[open]');
      var mobileFeaturedSection = activeMobilePanel && activeMobilePanel.querySelector('.snv-mobile-featured');

      if (openMobileSection) loadDeferredImages(openMobileSection);
      if (mobileFeaturedSection) loadDeferredImages(mobileFeaturedSection);

      if (!openMobileSection && !mobileFeaturedSection) {
        loadDeferredImages(activeMobilePanel || mobile);
      }
      return;
    }

    loadDeferredImages(details);
  }, true);

  function hydrateVisibleNavigation(root) {
    if (!root) return;

    root.querySelectorAll('[data-snv-desktop]').forEach(function (navigation) {
      var parentDetails = navigation.closest('details');
      if (!parentDetails || !parentDetails.open) return;

      var activePanel = navigation.querySelector('[data-snv-panel]:not([hidden])');
      var scope = activePanel || navigation;
      cancelPanelAnimations(activePanel);
      loadDeferredImages(scope);
      initCarousels(scope);
    });

    root.querySelectorAll('[data-snv-mobile]').forEach(function (navigation) {
      var drawer = navigation.closest('#MenuDrawer');
      if (drawer && drawer.hasAttribute('hidden')) return;

      var activePanel = navigation.querySelector('[data-snv-mobile-panel]:not([hidden])');
      var openSection = activePanel && activePanel.querySelector('details[open]');
      var featuredSection = activePanel && activePanel.querySelector('.snv-mobile-featured');

      if (openSection) loadDeferredImages(openSection);
      if (featuredSection) loadDeferredImages(featuredSection);

      if (!openSection && !featuredSection) {
        loadDeferredImages(activePanel || navigation);
      }
    });

    initCarousels(root);
  }

  function observeDrawer() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer || drawer.dataset.snvObserved === 'true') return;

    drawer.dataset.snvObserved = 'true';

    var observer = new MutationObserver(function () {
      if (!drawer.hasAttribute('hidden')) hydrateVisibleNavigation(drawer);
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['hidden', 'class']
    });
  }

  var insertionObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (
          node.matches('[data-snv-desktop], [data-snv-mobile], [data-snv-carousel]') ||
          node.querySelector('[data-snv-desktop], [data-snv-mobile], [data-snv-carousel]')
        ) {
          hydrateVisibleNavigation(node);
        }
      });
    });
  });

  function init() {
    observeDrawer();
    hydrateVisibleNavigation(document);
    insertionObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    observeDrawer();
    hydrateVisibleNavigation(event.target || document);
  });
})();
